<template>
  <div>
    <el-dialog title="Receive List" :close-on-click-modal="false" :visible.sync="visible" width="1000px" top="3vh">
      <div class="pb20">
        <el-table border :data="dataList" size="small" :max-height="tableMaxHeight" v-loading="dataListLoading" class="wdb100">
          <el-table-column prop="email" align="center" label="Email" width="260"></el-table-column>
          <!-- <el-table-column align="center" label="Receive Status" width="150">
          <template slot-scope="scope">
            <p v-if="scope.row.receiveStatus == 0">Not Received</p>
            <p v-if="scope.row.receiveStatus == 1">Received</p>
          </template>
        </el-table-column>
        <el-table-column prop="receiveTime" align="center" label="Received Time" width="166"></el-table-column> -->
          <el-table-column prop="clientCodeInfo.clientCode" align="center" label="Client Code" width="130"></el-table-column>
          <el-table-column prop="clientCodeInfo.uen" align="center" label="UEN" width="130"></el-table-column>
          <el-table-column prop="clientCodeInfo.companyName" align="center" label="Company Name"></el-table-column>
          <el-table-column align="center" width="120" fixed="right" label="Action">
            <template slot-scope="scope">
              <el-button type="text" class="fwb" @click="detailViewHandle(scope.row)">Detail</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 查看邮件详情 - 弹窗 -->
    <receive-detail ref="receiveDetail"></receive-detail>
  </div>
</template>

<script>
import ReceiveDetail from "./ReceiveDetail";
export default {
  components: {
    ReceiveDetail,
  },
  data() {
    return {
      visible: false,
      dataList: [],
      dataListLoading: false,
    };
  },
  computed: {
    tableMaxHeight() {
      // 80vh 换算为 px，element-ui 的 max-height 只支持数字
      return window.innerHeight * 0.8;
    },
  },
  methods: {
    async init(data) {
      this.visible = true;
      await this.$nextTick();
      this.getDataList(data);
    },
    // 获取列表
    getDataList(data) {
      this.dataListLoading = true;
      this.$http
        .get("/admin/promoEmailPushDetail/list", {
          params: {
            pushId: data.id,
          },
        })
        .then(res => {
          const resData = res.data || [];
          this.dataList = resData;
        })
        .finally(() => {
          this.dataListLoading = false;
        });
    },
    // 查看详情
    detailViewHandle(row) {
      this.$refs.receiveDetail.init(row);
    },
  },
};
</script>

<style lang="scss" scoped></style>
